import {
  GetMultipleChoiceSetsRequest,
  MultipleChoiceSet,
} from '@ulysses-inc/harami_api_client'
import Redux from 'redux'
import actions, {
  addMultipleChoiceSet as addMultipleChoiceSetAction,
  changeMultipleChoiceSetsPage as changeMultipleChoiceSetsPageAction,
  changeMultipleChoiceSetsSize as changeMultipleChoiceSetsSizeAction,
  getMultipleChoiceSet as getMultipleChoiceSetAction,
  getMultipleChoiceSets as getMultipleChoiceSetsAction,
  resetMultipleChoiceSet as resetMultipleChoiceSetAction,
  updateMultipleChoiceSet as updateMultipleChoiceSetAction,
} from './actions'

const getMultipleChoiceSets = (
  dispatch: Redux.Dispatch,
  request: GetMultipleChoiceSetsRequest,
) => {
  dispatch(getMultipleChoiceSetsAction(request))
}

const changeMultipleChoiceSetsPage = (
  dispatch: Redux.Dispatch,
  page: number,
  pageSize?: number,
) => {
  dispatch(changeMultipleChoiceSetsPageAction(page, pageSize))
}

const changeMultipleChoiceSetsSize = (
  dispatch: Redux.Dispatch,
  pageSize: number,
) => {
  dispatch(changeMultipleChoiceSetsSizeAction(pageSize))
}

const getMultipleChoiceSet = (
  dispatch: Redux.Dispatch,
  multipleChoiceSetId: string,
) => {
  dispatch(getMultipleChoiceSetAction(multipleChoiceSetId))
}

const deleteMultipleChoiceSet = (
  dispatch: Redux.Dispatch,
  multipleChoiceSetId: string,
) => {
  dispatch(actions.deleteMultipleChoiceSet(multipleChoiceSetId))
}

const addMultipleChoiceSet = (
  dispatch: Redux.Dispatch,
  multipleChoiceSet: MultipleChoiceSet,
) => {
  dispatch(addMultipleChoiceSetAction(multipleChoiceSet))
}

const updateMultipleChoiceSet = (
  dispatch: Redux.Dispatch,
  multipleChoiceSetId: string,
  multipleChoiceSet: MultipleChoiceSet,
) => {
  dispatch(
    updateMultipleChoiceSetAction(multipleChoiceSetId, multipleChoiceSet),
  )
}

const resetMultipleChoiceSet = (dispatch: Redux.Dispatch) => {
  dispatch(resetMultipleChoiceSetAction())
}

export default {
  getMultipleChoiceSets,
  changeMultipleChoiceSetsPage,
  changeMultipleChoiceSetsSize,
  getMultipleChoiceSet,
  deleteMultipleChoiceSet,
  addMultipleChoiceSet,
  updateMultipleChoiceSet,
  resetMultipleChoiceSet,
}
